export default function getActionElement(name, all) {
  const EL_HANDLER = `[data-action=${name}]`;

  if (all) {
    return document.querySelectorAll(EL_HANDLER)
  }

  return document.querySelector(EL_HANDLER);
}
